import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {CioFiltersDrawerContent} from '@/components/cio-filters-drawer-content'
import {
    Drawer,
    DrawerHeader,
    DrawerTrigger,
    DrawerContent,
    DrawerTitle,
    DrawerDescription
} from '@/components/ui/drawer'
import {cn} from '@/lib/utils'
import * as VisuallyHidden from '@radix-ui/react-visually-hidden'
import {SlidersHorizontalIcon} from 'lucide-react'
import {FilterTags} from '@/components/filterTags'

export const DrawerFilters = ({attributes, 'data-testid': dataTestId}) => {
    const [open, setOpen] = useState(false)
    const handleOpenChange = (open) => {
        setOpen(open === true ? true : false)
        return open
    }
    const {className, restAttributes} = attributes || {}
    return (
        <div className={cn('flex flex-col mt-2 mb-2', className)}>
            <Drawer
                direction="left"
                open={open}
                onOpenChange={handleOpenChange}
                {...restAttributes}
                data-testid={dataTestId || 'DrawerFilters'}
            >
                <DrawerTrigger
                    className="flex gap-2"
                    data-testid={dataTestId || 'DrawerFilters-DrawerTrigger'}
                >
                    <SlidersHorizontalIcon
                        data-testid={dataTestId || 'DrawerFilters-SlidersHorizontalIcon'}
                    />
                    <span>Filter</span>
                </DrawerTrigger>
                <DrawerContent data-testid={dataTestId || 'DrawerFilters-DrawerContent'}>
                    <VisuallyHidden.Root>
                        <DrawerTitle data-testid={dataTestId || 'DrawerFilters-DrawerTitle'} />
                        <DrawerDescription
                            data-testid={dataTestId || 'DrawerFilters-DrawerDescription'}
                        />
                    </VisuallyHidden.Root>
                    <DrawerHeader data-testid={dataTestId || 'DrawerFilters-DrawerHeader'} />
                    <CioFiltersDrawerContent
                        onOpenChange={handleOpenChange}
                        data-testid={dataTestId || 'DrawerFilters-CioFiltersDrawerContent'}
                    />
                </DrawerContent>
            </Drawer>
            <FilterTags data-testid={dataTestId || 'DrawerFilters-FilterTags'} />
        </div>
    )
}

DrawerFilters.propTypes = {
    attributes: PropTypes.object,
    'data-testid': PropTypes.string
}

export const BuilderDrawerFiltersDefinition = {
    component: DrawerFilters,
    name: 'DrawerFilters',
    noWrap: true
}
